import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button, Divider } from 'base-ui'

import { useProductPageContext } from '../productPageContext'

import { ProductPageOdsDialogServiceLinkButton } from './ProductPageOdsDialogServiceLinkButton'

export const ProductPageOdsDialogButtonsGroup: FC<{
  onlineDoctorServiceLink: string
}> = ({ onlineDoctorServiceLink }) => {
  const { productPageOdsConfig } = useProductPageContext()

  return (
    <div>
      <ProductPageOdsDialogServiceLinkButton href={onlineDoctorServiceLink} />

      <Divider className="my-4">
        <FormattedMessage id="general.label.or" />
      </Divider>

      <Button<'a'>
        className="w-full"
        href={productPageOdsConfig?.findStationaryDoctorUrl}
        rel="noopener noreferrer"
        slots={{ root: 'a' }}
        target="_blank"
      >
        <FormattedMessage id="pdp.buyboxwithvariants.odsModal.button.localsearch" />
      </Button>
    </div>
  )
}
